import React, { useEffect, useState } from 'react';

/**
 * "A correção está no ar mas a tela continua errada."
 *
 * [10/09/2026] Aba aberta antes do deploy segue rodando o JavaScript ANTIGO em
 * memória: o navegador só busca o bundle novo quando a página recarrega. Foi assim
 * que a trava do tomador subiu às 16:25 e a tela seguiu criando nota órfã às 16:35
 * (AUREUM, DPS 95 e 96) — e depois disso o operador ficou olhando a MESMA mensagem
 * de erro, congelada, sem nenhuma tentativa nova chegar ao servidor.
 *
 * Este aviso confere o build publicado (`asset-manifest.json`, que o servidor manda
 * com no-store) contra o que esta aba carregou e oferece o recarregar. NÃO recarrega
 * sozinho: quem está no meio de uma emissão perderia o formulário preenchido — a
 * decisão é do operador. Falha de rede não mostra nada (fail-open).
 */
const INTERVALO_MS = 120000;

async function versaoPublicada() {
  const r = await fetch('/asset-manifest.json', { cache: 'no-store' });
  if (!r.ok) throw new Error(`manifest ${r.status}`);
  const j = await r.json();
  return (j && j.files && j.files['main.js']) || '';
}

export default function AvisoVersaoNova() {
  const [temNova, setTemNova] = useState(false);

  useEffect(() => {
    let vivo = true;
    let carregada = null;   // a versão que ESTA aba está rodando

    const conferir = async () => {
      if (!vivo) return;
      try {
        const v = await versaoPublicada();
        if (!vivo || !v) return;
        if (carregada === null) { carregada = v; return; }
        if (v !== carregada) setTemNova(true);
      } catch (_) { /* sem rede: silêncio, não é problema do operador */ }
    };

    conferir();
    const timer = setInterval(conferir, INTERVALO_MS);
    window.addEventListener('focus', conferir);
    return () => { vivo = false; clearInterval(timer); window.removeEventListener('focus', conferir); };
  }, []);

  if (!temNova) return null;

  return (
    <div style={{
      position: 'fixed', left: '50%', transform: 'translateX(-50%)', bottom: 16, zIndex: 9999,
      display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
      borderRadius: 10, border: '1px solid var(--border)', background: 'var(--bg-card, #fff)',
      boxShadow: '0 6px 20px rgba(0,0,0,.12)', fontSize: 13.5, maxWidth: 'calc(100vw - 32px)',
    }}>
      <span style={{ color: 'var(--text)' }}>Há uma versão nova do cockpit. Atualize a página para usar as melhorias.</span>
      <button type="button" className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
        Atualizar agora
      </button>
    </div>
  );
}
